import { forwardRef } from 'react';

import { BaseInput } from '../BaseInput';
import type { SpecificInputProps } from '../BaseInput';

export type TelInputProps = SpecificInputProps;

/**
 * A tel input allows users to enter or edit a telephone number.
 *
 * {@link https://zeroheight.com/76c439891/v/latest/p/856f6e-text-input/b/87505a Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-telinput Code documentation}
 *
 * @example
 * <TelInput defaultValue="Input value" />
 */
export const TelInput = forwardRef<HTMLInputElement, TelInputProps>(
  (props: TelInputProps, ref): JSX.Element => (
    <BaseInput {...props} type="tel" ref={ref} />
  ),
);

TelInput.displayName = 'TelInput';

TelInput.defaultProps = {
  isDisabled: false,
  isInvalid: false,
  isRequired: false,
  isReadonly: false,
  size: 'm',
};
